/* A1 Kilts: Find Your Tartan.
 * Search suggestions: clans, family names (septs) and named tartans, shown while typing.
 * Matching: direct clan name, then sept surname, then tartan title words, then a close
 * spelling, then universal tartans.
 * Data comes from assets/a1-tartan-finder.json, built by scripts/build_tartan_finder.py.
 * Prices and images load live from /products/<handle>.js.
 */
(function () {
  // The header, homepage band and finder page each include this file; run it once.
  if (window.A1TartanFinderLoaded) return;
  window.A1TartanFinderLoaded = true;

  var TYPE_LABELS = { k: 'Kilts', s: "Women's skirts", a: 'Accessories' };
  var IGNORE = { clan: 1, tartan: 1, tartans: 1, kilt: 1, kilts: 1, the: 1, of: 1, family: 1, name: 1 };
  var MAX_SUGGESTIONS = 8;

  function norm(text) {
    return String(text)
      .normalize('NFKD').replace(/[̀-ͯ]/g, '')
      .replace(/\bM[c'’]\s?(?=[A-Za-z])/gi, 'Mac')
      .toLowerCase();
  }
  function words(text) { return norm(text).match(/[a-z]+/g) || []; }
  function compact(text) { return words(text).join(''); }
  function capitalise(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function distance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }

  // One shared copy of the data per page, loaded on first use.
  var dataPromises = {};
  function loadData(url) {
    if (!dataPromises[url]) {
      dataPromises[url] = fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (d) {
          d.words = d.p.map(function (p) { return words(p[1]); });
          d.septsOf = {};
          Object.keys(d.s).forEach(function (surname) {
            d.s[surname].forEach(function (clan) { (d.septsOf[clan] = d.septsOf[clan] || []).push(surname); });
          });
          // Suggestion index: [search key, label, kind, extra]
          d.index = [];
          Object.keys(d.c).forEach(function (k) { d.index.push([k, d.c[k][0], 'clan', d.c[k][1].length]); });
          Object.keys(d.s).forEach(function (k) { d.index.push([k, capitalise(k), 'sept', d.s[k]]); });
          (d.t || []).forEach(function (t) { d.index.push([compact(t[0]), t[0], 'tartan', t[1]]); });
          return d;
        })
        .catch(function (err) {
          delete dataPromises[url];
          throw err;
        });
    }
    return dataPromises[url];
  }

  function titleMatches(d, ws) {
    var out = [];
    d.words.forEach(function (tw, idx) {
      if (ws.every(function (w) { return tw.indexOf(w) !== -1; })) out.push(idx);
    });
    return out;
  }

  /* ---------- Suggestions (both layouts) ---------- */

  function Suggest(root, onChoose) {
    this.root = root;
    this.src = root.getAttribute('data-src');
    this.input = root.querySelector('input[name="surname"]');
    this.list = root.querySelector('[data-a1-tf-suggestions]');
    this.onChoose = onChoose;
    this.items = [];
    this.active = -1;
    this.data = null;

    var self = this;
    var warm = function () {
      loadData(self.src).then(function (d) { self.data = d; if (document.activeElement === self.input) self.update(); }).catch(function () {});
    };
    this.input.addEventListener('focus', warm, { once: true });
    this.input.addEventListener('input', function () { self.update(); });
    this.input.addEventListener('keydown', function (e) { self.key(e); });
    this.input.addEventListener('blur', function () { setTimeout(function () { self.close(); }, 120); });
    this.list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    this.list.addEventListener('click', function (e) {
      var li = e.target.closest('[data-index]');
      if (li) self.choose(+li.getAttribute('data-index'));
    });
  }

  // Every typed word starts a word in the name ("bla wat" -> "Black Watch").
  function startsWords(label, qWords) {
    var lw = words(label);
    return qWords.every(function (w) {
      return w.length > 1 && lw.some(function (x) { return x.indexOf(w) === 0; });
    });
  }

  Suggest.prototype.find = function (query) {
    var d = this.data;
    var q = compact(query);
    if (q.length < 2) return [];
    var qWords = words(query);
    var scored = [];

    d.index.forEach(function (entry) {
      var key = entry[0], score = -1;
      if (key === q) score = 0;
      else if (key.indexOf(q) === 0) score = 1;
      else if (entry[2] === 'tartan' && startsWords(entry[1], qWords)) score = 2;
      else if (q.length >= 4 && key.indexOf(q) > 0) score = 3;
      if (score < 0) return;
      // Clans before family names before tartans; bigger clans first.
      var kindRank = { clan: 0, sept: 1, tartan: 2 }[entry[2]];
      var size = entry[2] === 'clan' || entry[2] === 'tartan' ? entry[3] : 0;
      scored.push({ entry: entry, rank: score * 10 + kindRank, size: size });
    });

    // A close spelling when nothing starts with what was typed ("Frasier" -> Fraser).
    if (!scored.length && q.length >= 4) {
      d.index.forEach(function (entry) {
        if (entry[2] === 'tartan') return;
        var dist = distance(q, entry[0]);
        if (dist <= (q.length >= 6 ? 2 : 1)) scored.push({ entry: entry, rank: 50 + dist, size: 0, near: true });
      });
    }

    scored.sort(function (a, b) {
      return a.rank - b.rank || b.size - a.size || a.entry[1].localeCompare(b.entry[1]);
    });
    return scored.slice(0, MAX_SUGGESTIONS);
  };

  Suggest.prototype.meta = function (item) {
    var d = this.data, e = item.entry;
    if (e[2] === 'clan') return 'Clan · ' + e[3] + ' tartan' + (e[3] === 1 ? '' : 's');
    if (e[2] === 'sept') {
      return e[3].length === 1 ? 'Family name · Clan ' + d.c[e[3][0]][0] : 'Family name · ' + e[3].length + ' clans';
    }
    var n = titleMatches(d, words(e[1])).length;
    return 'Tartan · ' + n + ' product' + (n === 1 ? '' : 's');
  };

  Suggest.prototype.highlight = function (label, query) {
    var qWords = words(query);
    if (qWords.length > 1 && norm(label).length === label.length) {
      // Bold the start of each label word that a typed word begins ("bla wat" -> Black Watch).
      var used = {};
      return label.replace(/[A-Za-z']+/g, function (w) {
        var n = norm(w).replace(/[^a-z]/g, '');
        for (var i = 0; i < qWords.length; i++) {
          if (!used[i] && qWords[i].length > 1 && n.indexOf(qWords[i]) === 0) {
            used[i] = true;
            return '<mark>' + escapeHtml(w.slice(0, qWords[i].length)) + '</mark>' + escapeHtml(w.slice(qWords[i].length));
          }
        }
        return escapeHtml(w);
      });
    }
    var q = norm(query).replace(/[^a-z]/g, '');
    var plain = norm(label);
    // Find where the typed letters start in the label, ignoring spaces and punctuation.
    var letters = [], positions = [];
    for (var i = 0; i < plain.length; i++) {
      if (/[a-z]/.test(plain[i])) { letters.push(plain[i]); positions.push(i); }
    }
    var at = letters.join('').indexOf(q);
    if (!q || at === -1 || plain.length !== label.length) return escapeHtml(label);
    var start = positions[at], end = positions[at + q.length - 1] + 1;
    return escapeHtml(label.slice(0, start)) + '<mark>' + escapeHtml(label.slice(start, end)) + '</mark>' + escapeHtml(label.slice(end));
  };

  Suggest.prototype.update = function () {
    if (!this.data) return;
    var query = this.input.value;
    this.items = this.find(query);
    this.active = -1;
    if (!this.items.length) return this.close();

    var self = this;
    this.list.innerHTML = this.items.map(function (item, i) {
      return '<li role="option" id="' + self.list.id + '-' + i + '" data-index="' + i + '" aria-selected="false">' +
        '<span class="a1-tf__suggest-label">' + (item.near ? 'Did you mean ' : '') + self.highlight(item.entry[1], query) + (item.near ? '?' : '') + '</span>' +
        '<span class="a1-tf__suggest-meta">' + escapeHtml(self.meta(item)) + '</span></li>';
    }).join('');
    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  };

  Suggest.prototype.move = function (step) {
    if (!this.items.length) return;
    this.active = (this.active + step + this.items.length) % this.items.length;
    var self = this;
    this.list.querySelectorAll('[role="option"]').forEach(function (li, i) {
      li.setAttribute('aria-selected', i === self.active ? 'true' : 'false');
    });
    var current = this.list.querySelector('[data-index="' + this.active + '"]');
    this.input.setAttribute('aria-activedescendant', current.id);
    current.scrollIntoView({ block: 'nearest' });
  };

  Suggest.prototype.key = function (e) {
    var open = !this.list.hidden;
    if (e.key === 'ArrowDown') { e.preventDefault(); if (!open) this.update(); this.move(1); }
    else if (e.key === 'ArrowUp') { if (open) { e.preventDefault(); this.move(-1); } }
    else if (e.key === 'Escape') { if (open) { e.preventDefault(); this.close(); } }
    else if (e.key === 'Enter' && open && this.active >= 0) { e.preventDefault(); this.choose(this.active); }
  };

  Suggest.prototype.choose = function (i) {
    var entry = this.items[i].entry;
    this.input.value = entry[1];
    this.close();
    this.onChoose(entry[1]);
  };

  Suggest.prototype.close = function () {
    this.list.hidden = true;
    this.list.innerHTML = '';
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  };

  /* ---------- Results (full layout) ---------- */

  function Finder(root) {
    this.root = root;
    this.config = JSON.parse(root.querySelector('[data-a1-tf-config]').textContent);
    this.src = root.getAttribute('data-src');
    this.form = root.querySelector('form');
    this.input = root.querySelector('input[name="surname"]');
    this.results = root.querySelector('.a1-tf__results');
    this.status = root.querySelector('[data-a1-tf-status]');
    this.chips = root.querySelector('[data-a1-tf-chips]');
    this.grid = root.querySelector('[data-a1-tf-grid]');
    this.actions = root.querySelector('[data-a1-tf-actions]');
    this.cache = {};

    var self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.search(self.input.value);
    });
    root.querySelectorAll('[data-a1-tf-try]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        self.input.value = link.getAttribute('data-a1-tf-try');
        self.search(self.input.value);
      });
    });
    var initial = new URLSearchParams(location.search).get('surname');
    if (initial) {
      this.input.value = initial;
      this.search(initial, true);
    }
  }

  Finder.prototype.search = function (query, fromUrl) {
    var self = this;
    query = String(query || '').trim();
    if (!query) return;
    if (!fromUrl) {
      var url = new URL(location.href);
      url.searchParams.set('surname', query);
      history.replaceState(null, '', url);
    }
    this.results.hidden = false;
    this.setStatus('<h3>Searching…</h3>');
    this.chips.innerHTML = this.grid.innerHTML = this.actions.innerHTML = '';

    loadData(this.src).then(function (d) {
      self.render(self.match(d, query), d);
      if (!fromUrl) self.results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }).catch(function () {
      self.setStatus('<h3>The tartan finder didn’t load</h3><p>Check your connection and search again, or <a href="' +
        self.config.root + 'search?type=product&q=' + encodeURIComponent(query) + '">search the store</a>.</p>');
    });
  };

  // Returns { kind, query, clan?, clans?, items }
  Finder.prototype.match = function (d, query) {
    var ws = words(query).filter(function (w) { return !IGNORE[w]; });
    if (!ws.length) ws = words(query);
    var byTitle = titleMatches(d, ws);
    var asClan = function (k) {
      k = (d.a && d.a[k]) || k;
      if (d.c[k]) return { kind: 'clan', query: query, clan: k, items: d.c[k][1] };
      if (d.s[k]) return { kind: 'sept', query: query, surname: k, clans: d.s[k], clan: d.s[k][0], items: d.c[d.s[k][0]][1] };
      return null;
    };

    // 1. The whole query as one name ("Mac Donald" -> macdonald).
    var found = asClan(ws.join(''));
    if (found) return found;
    // 2. Several words that all appear in tartan titles ("Black Watch", "Pride of Scotland").
    if (ws.length > 1 && byTitle.length) return { kind: 'title', query: query, items: byTitle };
    // 3. Each word as a surname, last word first ("John Fraser" -> fraser).
    for (var i = ws.length - 1; i >= 0; i--) {
      found = asClan(ws[i]);
      if (found) return found;
    }
    // 4. A single word that appears in tartan titles ("Cavan", "Hebridean").
    if (byTitle.length) return { kind: 'title', query: query, items: byTitle };

    var last = ws[ws.length - 1], best = null, bestD = last.length >= 6 ? 2 : 1;
    Object.keys(d.c).concat(Object.keys(d.s)).forEach(function (key) {
      var dist = distance(last, key);
      if (dist <= bestD && (!best || dist < best.d)) best = { key: key, d: dist };
    });
    if (best) {
      if (d.c[best.key]) return { kind: 'near', query: query, clan: best.key, items: d.c[best.key][1] };
      var clans = d.s[best.key];
      return { kind: 'near-sept', query: query, surname: best.key, clans: clans, clan: clans[0], items: d.c[clans[0]][1] };
    }
    return { kind: 'none', query: query, items: d.u };
  };

  Finder.prototype.clanName = function (d, key) { return d.c[key] ? d.c[key][0] : key; };

  Finder.prototype.render = function (m, d) {
    var self = this;
    var q = escapeHtml(m.query);
    var clanName = m.clan ? escapeHtml(this.clanName(d, m.clan)) : '';
    var searchUrl = this.config.root + 'search?type=product&q=';
    var septList = function (clan) {
      var s = (d.septsOf[clan] || []).slice(0, 8).map(capitalise);
      return s.length ? ' Surnames linked to this clan include ' + escapeHtml(s.join(', ')) + '.' : '';
    };
    var html;

    if (m.kind === 'clan') {
      html = '<p class="a1-tf__eyebrow">Clan ' + clanName + '</p><h3>' + m.items.length + ' ' + clanName +
        ' tartan' + (m.items.length === 1 ? '' : 's') + '</h3><p>Every piece we make in a ' + clanName +
        ' tartan, including its modern, ancient and weathered colourways.' + septList(m.clan) + '</p>';
    } else if (m.kind === 'sept' || m.kind === 'near-sept') {
      var names = m.clans.map(function (c) { return escapeHtml(self.clanName(d, c)); });
      var surname = escapeHtml(capitalise(m.surname));
      var lead = m.kind === 'near-sept' ? 'Showing results for “' + surname + '”. ' : '';
      html = '<p class="a1-tf__eyebrow">' + surname + '</p><h3>' + surname + ' is associated with ' +
        (names.length === 1 ? 'Clan ' + names[0] : 'several clans') + '</h3><p>' + lead +
        (names.length > 1 ? 'Families named ' + surname + ' are linked to Clans ' + names.join(', ') + '. Pick one below to see its tartans.' :
          'Families named ' + surname + ' traditionally wear the ' + names[0] + ' tartan. Here is every ' + names[0] + ' tartan we make.') + '</p>';
    } else if (m.kind === 'title') {
      html = '<p class="a1-tf__eyebrow">Tartan search</p><h3>' + m.items.length + ' tartan' + (m.items.length === 1 ? '' : 's') +
        ' matching “' + q + '”</h3>';
    } else if (m.kind === 'near') {
      html = '<p class="a1-tf__eyebrow">Closest match</p><h3>Did you mean ' + clanName + '?</h3><p>We didn’t find “' + q +
        '” exactly, so here are the ' + clanName + ' tartans.</p>';
    } else {
      html = '<p class="a1-tf__eyebrow">No clan match yet</p><h3>We couldn’t match “' + q + '” to a clan</h3>' +
        '<p>Not every surname has its own tartan. These tartans can be worn by anyone, with no clan connection needed. You can also <a href="' +
        searchUrl + encodeURIComponent(m.query) + '">search the whole store</a> or contact us and we’ll help you choose.</p>';
    }
    this.setStatus(html);
    this.renderChips(m, d);
  };

  Finder.prototype.renderChips = function (m, d) {
    var self = this;
    this.chips.innerHTML = '';

    if (m.clans && m.clans.length > 1) {
      m.clans.forEach(function (clan, idx) {
        self.addChip('Clan ' + self.clanName(d, clan), idx === 0, function () {
          self.showItems(d.c[clan][1], d);
        });
      });
      this.showItems(d.c[m.clans[0]][1], d);
      return;
    }

    var groups = { all: m.items };
    m.items.forEach(function (i) { var t = d.p[i][2]; (groups[t] = groups[t] || []).push(i); });
    var types = ['k', 's', 'a'].filter(function (t) { return groups[t]; });
    if (types.length > 1) {
      this.addChip('All (' + m.items.length + ')', true, function () { self.showItems(groups.all, d); });
      types.forEach(function (t) {
        self.addChip(TYPE_LABELS[t] + ' (' + groups[t].length + ')', false, function () { self.showItems(groups[t], d); });
      });
    }
    this.showItems(m.items, d);
  };

  Finder.prototype.addChip = function (label, pressed, onClick) {
    var chips = this.chips;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'a1-tf__chip';
    b.textContent = label;
    b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    b.addEventListener('click', function () {
      chips.querySelectorAll('.a1-tf__chip').forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      onClick();
    });
    chips.appendChild(b);
  };

  Finder.prototype.showItems = function (items, d, start) {
    var self = this;
    var size = this.config.pageSize || 12;
    start = start || 0;
    if (!start) this.grid.innerHTML = '';
    items.slice(start, start + size).forEach(function (i) { self.grid.appendChild(self.card(d.p[i])); });
    this.actions.innerHTML = '';
    if (items.length > start + size) {
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'a1-tf__more';
      more.textContent = 'Show more (' + (items.length - start - size) + ')';
      more.addEventListener('click', function () { self.showItems(items, d, start + size); });
      this.actions.appendChild(more);
    }
  };

  Finder.prototype.card = function (p) {
    var self = this;
    var handle = p[0], title = p[1];
    var url = this.config.root + 'products/' + handle;
    var el = document.createElement('article');
    el.className = 'a1-tf__card a1-tf__card--loading';
    el.innerHTML = '<a class="a1-tf__card-media" href="' + url + '" tabindex="-1" aria-hidden="true"></a>' +
      '<a class="a1-tf__card-title" href="' + url + '">' + escapeHtml(title) + '</a><div class="a1-tf__card-price"></div>';
    this.product(handle).then(function (prod) {
      el.classList.remove('a1-tf__card--loading');
      if (!prod) return;
      var img = prod.featured_image;
      if (img) {
        var src = img.indexOf('//') === 0 ? 'https:' + img : img;
        var join = src.indexOf('?') === -1 ? '?' : '&';
        el.querySelector('.a1-tf__card-media').innerHTML = '<img loading="lazy" alt="" src="' + src + join + 'width=600" srcset="' +
          src + join + 'width=360 360w, ' + src + join + 'width=600 600w" sizes="(min-width: 990px) 25vw, 50vw">';
      }
      var price = self.money(prod.price);
      if (prod.compare_at_price > prod.price) price += '<s>' + self.money(prod.compare_at_price) + '</s>';
      el.querySelector('.a1-tf__card-price').innerHTML = price;
    });
    return el;
  };

  Finder.prototype.product = function (handle) {
    if (!this.cache[handle]) {
      this.cache[handle] = fetch(this.config.root + 'products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return this.cache[handle];
  };

  Finder.prototype.money = function (cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = amount.replace(/\.00$/, '');
    return String(this.config.moneyFormat || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return key.indexOf('no_decimals') !== -1 ? noDecimals : amount;
    });
  };

  Finder.prototype.setStatus = function (html) { this.status.innerHTML = html; };

  /* ---------- Header search (snippets/a1-header-search.liquid) ---------- */

  function HeaderSearch(root) {
    this.root = root;
    this.src = root.getAttribute('data-src');
    this.finderUrl = root.getAttribute('data-finder-url');
    this.rootUrl = root.getAttribute('data-root') || '/';
    this.moneyFormat = root.getAttribute('data-money') || '${{amount}}';
    this.form = root.querySelector('form');
    this.input = root.querySelector('input[name="q"]');
    this.list = root.querySelector('[role="listbox"]');
    this.data = null;
    this.items = [];
    this.active = -1;
    this.productCache = {};
    this.timer = null;

    var self = this;
    this.input.addEventListener('focus', function () {
      loadData(self.src).then(function (d) {
        self.data = d;
        if (document.activeElement === self.input && self.input.value.trim().length > 1) self.update();
      }).catch(function () {});
    });
    this.input.addEventListener('input', function () { self.update(); });
    this.input.addEventListener('keydown', function (e) { self.key(e); });
    this.input.addEventListener('blur', function () { setTimeout(function () { self.close(); }, 150); });
    this.list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    this.list.addEventListener('click', function (e) {
      var li = e.target.closest('[data-index]');
      if (li) self.choose(+li.getAttribute('data-index'));
    });
  }

  HeaderSearch.prototype.update = function () {
    var self = this;
    var q = this.input.value.trim();
    clearTimeout(this.timer);
    if (q.length < 2) return this.close();
    this.render(q);
    if (this.productCache[q]) return;
    // Shopify's predictive search for products, after a short pause in typing.
    this.timer = setTimeout(function () {
      fetch(self.rootUrl.replace(/\/?$/, '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
          self.productCache[q] = list.map(function (p) {
            return { title: p.title, url: p.url, price: p.price, image: (p.featured_image && p.featured_image.url) || p.image };
          });
          if (self.input.value.trim() === q && document.activeElement === self.input) self.render(q);
        })
        .catch(function () { self.productCache[q] = []; });
    }, 180);
  };

  HeaderSearch.prototype.money = function (amount) {
    var n = Number(amount);
    if (isNaN(n)) return '';
    var fixed = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return this.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return key.indexOf('no_decimals') !== -1 ? fixed.replace(/\.00$/, '') : fixed;
    });
  };

  HeaderSearch.prototype.render = function (q) {
    var self = this;
    var finder = this.data ? Suggest.prototype.find.call(this, q).slice(0, 4) : [];
    var products = this.productCache[q] || [];
    var html = '';
    this.items = [];
    this.active = -1;

    if (finder.length) {
      html += '<li class="a1-hs__group" role="presentation">Clans &amp; tartans</li>';
      finder.forEach(function (item) {
        var i = self.items.push({ kind: 'finder', label: item.entry[1] }) - 1;
        html += '<li class="a1-hs__item" role="option" id="a1-hs-opt-' + i + '" data-index="' + i + '" aria-selected="false">' +
          '<span class="a1-hs__item-label">' + (item.near ? 'Did you mean ' : '') + Suggest.prototype.highlight(item.entry[1], q) + (item.near ? '?' : '') + '</span>' +
          '<span class="a1-hs__item-meta">' + escapeHtml(Suggest.prototype.meta.call(self, item)) + '</span></li>';
      });
    }
    if (products.length) {
      html += '<li class="a1-hs__group" role="presentation">Products</li>';
      products.forEach(function (p) {
        var i = self.items.push({ kind: 'product', url: p.url }) - 1;
        var img = p.image ? '<img class="a1-hs__thumb" alt="" loading="lazy" src="' + escapeHtml(p.image) + (p.image.indexOf('?') === -1 ? '?' : '&') + 'width=96">' : '<span class="a1-hs__thumb"></span>';
        html += '<li class="a1-hs__item" role="option" id="a1-hs-opt-' + i + '" data-index="' + i + '" aria-selected="false">' + img +
          '<span class="a1-hs__item-label">' + escapeHtml(p.title) + '</span><span class="a1-hs__item-meta">' + escapeHtml(self.money(p.price)) + '</span></li>';
      });
    }
    var all = this.items.push({ kind: 'all' }) - 1;
    html += '<li class="a1-hs__item a1-hs__item--all" role="option" id="a1-hs-opt-' + all + '" data-index="' + all + '" aria-selected="false">' +
      '<span class="a1-hs__item-label">Search the store for “' + escapeHtml(q) + '”</span></li>';

    this.list.innerHTML = html;
    this.list.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.input.removeAttribute('aria-activedescendant');
  };

  HeaderSearch.prototype.key = function (e) {
    var open = !this.list.hidden && this.items.length;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!open) return;
      e.preventDefault();
      this.active = (this.active + (e.key === 'ArrowDown' ? 1 : -1) + this.items.length) % this.items.length;
      var self = this;
      this.list.querySelectorAll('[role="option"]').forEach(function (li) {
        li.setAttribute('aria-selected', li.getAttribute('data-index') === String(self.active) ? 'true' : 'false');
      });
      var current = this.list.querySelector('[data-index="' + this.active + '"]');
      this.input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Escape' && open) {
      e.preventDefault();
      this.close();
    } else if (e.key === 'Enter' && open && this.active >= 0) {
      e.preventDefault();
      this.choose(this.active);
    }
  };

  HeaderSearch.prototype.choose = function (i) {
    var item = this.items[i];
    if (!item) return;
    if (item.kind === 'finder') {
      location.href = this.finderUrl + (this.finderUrl.indexOf('?') === -1 ? '?' : '&') + 'surname=' + encodeURIComponent(item.label);
    } else if (item.kind === 'product') {
      location.href = item.url;
    } else {
      this.close();
      this.form.submit();
    }
  };

  HeaderSearch.prototype.close = function () {
    this.list.hidden = true;
    this.list.innerHTML = '';
    this.items = [];
    this.active = -1;
    this.input.setAttribute('aria-expanded', 'false');
    this.input.removeAttribute('aria-activedescendant');
  };

  /* ---------- Start-up ---------- */

  function init() {
    document.querySelectorAll('[data-a1-header-search]').forEach(function (root) {
      if (!root.a1HeaderSearch) root.a1HeaderSearch = new HeaderSearch(root);
    });
    document.querySelectorAll('[data-a1-tf-root]').forEach(function (root) {
      if (root.a1Suggest) return;
      var finder = root.hasAttribute('data-a1-tartan-finder') ? (root.a1Finder = new Finder(root)) : null;
      var form = root.querySelector('form');
      // Compact band: open the results page. Built by hand so a "?view=" in the action survives.
      var open = function (value) {
        var action = form.getAttribute('action');
        location.href = action + (action.indexOf('?') === -1 ? '?' : '&') + 'surname=' + encodeURIComponent(value);
      };
      if (!finder) {
        form.addEventListener('submit', function (e) {
          var value = form.querySelector('input[name="surname"]').value.trim();
          e.preventDefault();
          if (value) open(value);
        });
      }
      root.a1Suggest = new Suggest(root, function (value) {
        if (finder) finder.search(value);
        else open(value);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-initialise when the section is added or edited in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
